{
  "common" : {
    "customFieldExistsError" : "Personalizzato Campo con questo nome esiste già",
    "uniqueKeyNotUniqueError" : "Questa Chiave non è l'unica",
    "save" : "Salva",
    "saving" : "Salvataggio",
    "integrate" : "Integra",
    "preview" : "Anteprima",
    "back" : "Indietro",
    "alert" : "Avviso",
    "proceed" : "Procedi",
    "cancel" : "Annulla",
    "delete" : "Elimina",
    "embed" : "Incorpora",
    "link" : "Link",
    "iframeEmbed" : "Incorporamento Iframe",
    "styles" : "Stili",
    "options" : "Opzioni",
    "quickAdd" : "Aggiunta rapida",
    "customFields" : "Campi personalizzati",
    "personalInfo" : "Informazioni personali",
    "contactInfo" : "Informazioni di contatto",
    "submit" : "Invia",
    "address" : "Indirizzo",
    "customized" : "Personalizzato",
    "layout" : "Layout",
    "showLabel" : "Mostra etichetta",
    "background" : "Sfondo",
    "buttonBackground" : "Sfondo Pulsante",
    "fontColour" : "Colore Carattere",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Seleziona Tema",
    "filled" : "Compilato",
    "textOnly" : "Solo corpo",
    "border" : "Bordo",
    "borderType" : "Tipo di bordo",
    "cornerRadius" : "Raggio d'angolo",
    "width" : "Larghezza",
    "padding" : "Spaziatura interna",
    "top" : "Superiore",
    "bottom" : "Inferiore",
    "left" : "Sinistra",
    "right" : "Destra",
    "center" : "Centro",
    "default" : "Form Default",
    "shadow" : "Ombra",
    "color" : "Colore",
    "horizontal" : "Orizzontale",
    "vertical" : "Verticale",
    "blur" : "Sfocatura",
    "spread" : "Diffondi",
    "fieldStyle" : "Stile del campo",
    "fontColor" : "Colore del carattere",
    "label" : "Etichetta",
    "fontFamily" : "Famiglia di caratteri",
    "size" : "Dimensione",
    "weight" : "Peso",
    "placeholder" : "Segnaposto",
    "customCSS" : "CSS personalizzato",
    "backgroundImage" : "Immagine di sfondo",
    "headerImage" : "Immagine dell'intestazione",
    "miscellaneous" : "Varie",
    "agencyBranding" : "Branding dell'agenzia",
    "imageUploadMessage" : "Fai clic su un file immagine o trascinalo in quest'area per caricarlo",
    "backgroundImageTooltipMessage" : "L'immagine di sfondo deve coprire l'intera pagina, fornendo uno sfondo visivamente accattivante per il modulo. Per visualizzare l'immagine di sfondo, fai clic sull'opzione Anteprima.",
    "headerImageTooltipMessage" : "L'immagine dell'intestazione è progettata per coprire l'intera larghezza del modulo e rimane posizionata nella parte superiore del modulo. Per visualizzare l'immagine dell'intestazione, fai clic sull'opzione Anteprima.",
    "onSubmit" : "All'invio",
    "facebookPixelID" : "ID pixel di Facebook",
    "facebookPixelIDMessage" : "Ignora questo campo se prevedi di utilizzare questo modulo/sondaggio all'interno di un funnel",
    "facebookPixelEvents" : "Eventi del pixel di Facebook",
    "onpageView" : "Visualizzazione sulla pagina",
    "stickyContact" : "Contatto frequente",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Descrizione del campo",
    "fieldTitle" : "Titolo del campo",
    "queryKey" : "Chiave della query",
    "querykeyTooltipMessage" : "La chiave della query che può essere usata come parametro dell'URL per popolare questo campo",
    "required" : "Obbligatorio",
    "hidden" : "Nascosto",
    "hiddenValue" : "Valore nascosto",
    "enableCountryPicker" : "Abilita selettore di paese",
    "altText" : "Testo alternativo",
    "alignment" : "Allineamento",
    "imageWidth" : "Larghezza dell'immagine",
    "imageHeight" : "Altezza dell'immagine",
    "logic" : "Logica",
    "pleaseInput" : "Inserisci",
    "editHTML" : "Modifica HTML",
    "textStyle" : "Stile del testo",
    "subText" : "Testo secondario",
    "text" : "Testo",
    "buttonStyle" : "Stile del pulsante",
    "fullWidth" : "Larghezza completa",
    "htmlMessage" : "L'HTML personalizzato va qui",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONALIZZATO",
    "htmlEditorBodyMessage" : "Aggiungi qui il tuo codice",
    "yesSave" : "Sì, salva",
    "cancelKeep" : "Annulla, mantieni",
    "done" : "Fatto",
    "addElement" : "Aggiungi elemento",
    "addUrlLike" : "Aggiungi URL validi come",
    "doNotAddRelativePath" : "Non aggiungere percorsi relativi come",
    "or" : "o",
    "addCustomFields" : "Aggiungi campi personalizzati",
    "customFieldSearch" : "Cerca per nome",
    "enterSourceValue" : "Inserisci il valore della fonte",
    "shortLabel" : "Etichetta breve",
    "shortLabelPlaceholder" : "Carattere a Etichetta breve",
    "labelPlaceholder" : "Digita un'etichetta",
    "fileUploadPlaceholder" : "Carica un File",
    "customCSSTooltip" : "Il CSS personalizzato ha la precedenza sullo stile dei moduli e sui temi e può avere un impatto sullo stile del tema.",
    "fontFamilyTooltip" : "Builder supporta tutti i tipi di font, se non lo vedi nell'elenco. Cercalo nel menu a discesa",
    "useGDPRCompliantFont" : "Usa carattere conforme al GDPR",
    "enableTimezone" : "Abilita fuso orario",
    "inputStyle" : "Stile di inserimento",
    "conditionalLogicAlertOnSubmit" : "La logica condizionale avrà la precedenza sul messaggio/reindirizzamento",
    "conditionalLogicAlertOnShowHide" : "La logica condizionale avrà la precedenza sulle impostazioni nascoste",
    "placeholderFacebookPixelIdInput" : "Inserisci l'ID pixel di Facebook",
    "doNotShowMessage" : "Non mostrare più",
    "creatingForm" : "Crea il tuo modulo...",
    "creatingSurvey" : "Crea il tuo Sondaggio...",
    "creatingQuiz" : "Crea il tuo quiz...",
    "errorCreatingForm" : "Lì è stato un errore Crea il tuo Modulo. Riprova.",
    "errorCreatingSurvey" : "Lì è stato un errore Crea il tuo Sondaggio. Riprova.",
    "errorCreatingQuiz" : "Lì è stato un errore Crea il tuo quiz. Riprova.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Temi",
      "alertThemeMessage" : "Il cambio di tema comporterà la perdita di tutte le modifiche di stile attuali.",
      "useTheme" : "Utilizza il tema",
      "removeTheme" : "Rimuovi il tema"
    },
    "box" : "Casella",
    "line" : "Linea",
    "message" : "Messaggio",
    "openUrl" : "Apri URL",
    "borderTypeList" : {
      "dotted" : "Punteggiato",
      "dashed" : "Tratteggiato",
      "solid" : "Uniforme",
      "none" : "Nessuno"
    },
    "button" : "Pulsante",
    "emailNotification" : "Notifica email",
    "emailNotificationSubheader" : "Ricevi un'e-mail quando qualcuno compila il tuo modulo",
    "subject" : "Oggetto",
    "emailTo" : "Email (a)",
    "senderName" : "Nome del mittente",
    "senderNameWarning" : "Il tuo (nome del sottoaccount) verrà aggiunto se lasciato vuoto",
    "emailError" : "È richiesto almeno un indirizzo email",
    "emailTooltip" : "Il primo indirizzo email è designato per il campo \"A\". Tutti gli indirizzi email successivi verranno inclusi nel campo \"Cc\".",
    "clear" : "Rimuovi",
    "showNotificationsSettings" : "Mostra impostazioni delle notifiche",
    "emailServicePaid" : "Questa funzionalità è un servizio a pagamento e comporterà costi in base all'utilizzo.",
    "integration" : "Integrazione",
    "validation" : {
      "fieldRequired" : "Campo è Obbligatorio",
      "maxLengthExceeded" : "Massimo Lunghezza ha superato ({max} Carattere)"
    },
    "payment" : {
      "payments" : "Pagamenti",
      "connected" : "Collegato",
      "connect" : "Collega",
      "liveModeOn" : "Modalità live",
      "status" : "Stato",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Campi di pagamento",
      "suggestAnAmount" : "Suggerisci un importo",
      "selectCurrency" : "Seleziona la valuta",
      "tagActiveBGColor" : "Colore etichetta attiva",
      "includeOtherAmount" : "Includi altro importo",
      "footerInfo" : "Info piè di pagina",
      "paymentType" : "Tipo di pagamento",
      "sellProducts" : "Vendi prodotti",
      "customAmount" : "Importo personalizzato",
      "collectPayment" : "Raccogli pagamento",
      "generalSettings" : "Campi generali",
      "securePayments" : "*Blocca al 100% e pagamenti sicuri*",
      "error" : {
        "addMainProductFirst" : "Aggiungi prima un PRIMARIO Prodotto",
        "priceNotFoundForBumpProduct" : "Prezzo non trovato per il Prodotto aggiuntivo",
        "productAlreadyAdded" : "Prodotto già aggiunto"
      },
      "product" : {
        "addProduct" : "Aggiungi prodotto",
        "productSettings" : "Impostazioni prodotto",
        "selectProduct" : "Seleziona prodotto",
        "editThisProduct" : "Per modificare questo prodotto",
        "clickHere" : "Fai clic qui",
        "show" : "Mostra",
        "description" : "Descrizione",
        "image" : "Immagine",
        "layoutSettings" : "Impostazioni di layout",
        "singleColumn" : "Colonna singola",
        "twoColumn" : "Due colonne",
        "threeColumn" : "Tre colonne",
        "maxProductError" : "In un modulo sono consentiti al massimo 20 prodotti",
        "productSelectPlaceholder" : "Seleziona un prodotto",
        "orderConfirmation" : "Conferma dell'ordine",
        "orderConfirmationWarning" : "Una volta che il pagamento è andato a buon fine, verrà visualizzata una pagina di conferma dell'ordine",
        "quantity" : "Quantità",
        "createProduct" : "Per creare un prodotto",
        "noProductsAdded" : "Nessun prodotto ancora aggiunto",
        "productsWillShowHere" : "Una volta che i prodotti Tu Includi, mostreranno Destra qui",
        "chooseProductType" : "Seleziona prodotto digitale",
        "mainProduct" : "PRIMARIO Prodotto"
      },
      "bumProduct" : {
        "price" : "Prezzo",
        "variant" : "Variante",
        "headline" : "Titolo",
        "otoHeadline" : "Titolo OTO",
        "otoText" : "OTO Corpo",
        "enableImage" : "Abilita Immagine",
        "imageMessage" : "Afferriamo il Predefinito Prodotto Immagine",
        "orUploadADifferentImage" : "O Carica a different Immagine",
        "bumpProducts" : "Prodotti aggiuntivi",
        "bumpProduct" : "Prodotto aggiuntivo",
        "enableBump" : "Abilita urto",
        "orderBumpStyle" : "Offerta aggiuntiva Stile aggiuntivo",
        "classic" : "Classico",
        "modern" : "Moderno",
        "icon" : "Icona",
        "bumpTemplate" : "Seleziona Modello",
        "highlightText" : "Evidenzia Corpo",
        "showPrice" : "Mostra Prezzo",
        "bumpPriceColor" : "Prezzo aggiuntivo",
        "bumpIconColor" : "Icona di urto",
        "bumpBackgroundColor" : "Sfondo a Sfondo",
        "highlightTextColor" : "Evidenzia Corpo",
        "headlineColor" : "Titolo",
        "otoHeadlineColor" : "Titolo OTO",
        "otoTextColor" : "OTO Corpo",
        "bumpBorderColor" : "Bordo a Bordo",
        "priceRequired" : "Il prezzo è obbligatorio",
        "headlineRequired" : "Il titolo è Obbligatorio",
        "bumpProductTooltip" : "Un Piccolo Componente aggiuntivo offerto durante Pagamento a Moltiplica Ordina Valore. I Clienti possono includerlo con un Individuo fai clic.",
        "templateOne" : "Modello 1",
        "templateTwo" : "Modello 2",
        "templateThree" : "Modello 3",
        "animationIcon" : {
          "none" : "Nessuno",
          "arrow" : "Freccia",
          "fire" : "Fuoco",
          "plus" : "Più",
          "giftBox" : "Casella regalo",
          "timer" : "Conto alla rovescia",
          "cracker" : "Cracker",
          "snack" : "Spuntino",
          "partyBalloon" : "Palloncino per feste",
          "flash" : "Flash",
          "money" : "Valuta",
          "spaceShuttle" : "Navetta Spazio"
        }
      },
      "coupons" : {
        "coupons" : "Coupon",
        "enableCoupon" : "Abilita coupon",
        "couponAlignment" : "Allineamento del coupon",
        "left" : "Sinistra",
        "right" : "Destra",
        "fullWidth" : "Larghezza completa",
        "tooltipMessage" : "Imposta la posizione di inserimento del coupon dai tipi sottostanti"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Indirizzo a completamento automatico",
      "addressfields" : "Campi indirizzo",
      "placeholderSearch" : "Cerca un indirizzo",
      "autoCompleteTooltip" : "Fornisce la possibilità di cercare e popolare automaticamente l'indirizzo. Questa funzione è a pagamento.",
      "streetAddress" : "Indirizzo",
      "autoCompleteAddressTitle" : "Automatico Termina Indirizzo",
      "newBadge" : "Nuovo",
      "defaultLabel" : "Indirizzo",
      "searchPlaceholder" : "Cerca Indirizzo",
      "mandataorySearch" : {
        "title" : "Obbligatorio a selezionare Indirizzo in Cerca Bar",
        "primaryText" : "Completamento automatico solo per Indirizzo",
        "secondaryText" : "Quando Abilitato, quando un utente interagisce con l'Indirizzo Campo, Poi deve selezionare un Indirizzo valido per Procedi.",
        "secondaryText1" : "Quando Disabilitato Poi possono Procedi senza selezionare un Indirizzo in barra Cerca."
      }
    },
    "autoResponder" : "Risponditore automatico",
    "autoResponderSubheader" : "Invia un'email automatica alla persona che invia il modulo (l'email include una copia delle informazioni inserite nel modulo)",
    "replyToEmail" : "Rispondi all'email",
    "open" : "Aperta",
    "won" : "Vinta",
    "lost" : "Persa",
    "abandon" : "Abbandona",
    "selectAPipeline" : "Seleziona una sequenza",
    "stage" : "Fase",
    "status" : "Stato",
    "opportunityValue" : "Valore dell'opportunità",
    "createNewPipeline" : "Crea una nuova sequenza",
    "editOpportunitySettings" : "Modifica le impostazioni delle opportunità",
    "contact" : "Contatto",
    "opportunity" : "Opportunità",
    "add" : "Aggiungi",
    "more" : "Più",
    "opportunityHeading" : "Dove vuoi che la tua opportunità venga aggiornata?",
    "date" : {
      "dateSettings" : "Impostazioni data",
      "dateFormat" : "Formato data",
      "dateSeparator" : "Separatore di data",
      "dateFormatTooltipMessage" : "Seleziona un formato di data. D sta per giorno, M per mese e Y per anno",
      "dateSeparatorTooltipMessage" : "Seleziona un separatore che separerà giorno, mese e anno nel formato selezionato in Formato data",
      "disablePicker" : "Disabilita selettore"
    },
    "restoreVersion" : "Ripristina versione",
    "versionHistory" : "Cronologia delle versioni",
    "errorMessage" : "Errore, riprova di nuovo",
    "version" : "Versione:",
    "currentVersion" : "Versione attuale",
    "messageStyling" : "Stile dei messaggi",
    "validateEmailHeader" : "Convalida email",
    "validateEmailDescription" : "Il pulsante diventerà visibile una volta che l'utente avrà inserito la propria email. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "validatePhoneHeader" : "Convalida telefono",
    "validatePhoneDescription" : "Il pulsante diventerà visibile una volta che l'utente avrà inserito il proprio numero di telefono. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "validatePhoneWarning" : "Per abilitare la verifica OTP via SMS, assicurati che il tuo numero di telefono sia configurato nelle tue impostazioni di luogo",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Tipo di modulo",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "Una colonna",
      "twoColumn" : "Due colonne",
      "singleLine" : "Linea singola",
      "fieldWidth" : "Larghezza del campo",
      "labelAlignment" : {
        "labelAlignment" : "Allineamento etichetta",
        "labelWidth" : "Larghezza etichetta"
      },
      "fieldSpacing" : "Spaziatura dei campi",
      "color" : "colore",
      "fontColor" : "Colore del carattere",
      "inputBackground" : "Sfondo di input",
      "layout" : "Layout",
      "colorsAndBackground" : "Colori e sfondo",
      "advanceSettings" : "Impostazioni avanzate",
      "inputField" : "Campo di inserimento",
      "borderWidth" : "Larghezza del bordo",
      "borderColor" : "Colore del bordo",
      "borderStyle" : "Stile del bordo",
      "fontSize" : "Dimensione del carattere",
      "fontWeight" : "Peso del carattere",
      "labelColor" : "Colore etichetta",
      "placeholderColor" : "Colore segnaposto",
      "shortLabelColor" : "Colore dell'etichetta breve"
    },
    "replyToTooltip" : "Personalizza l'indirizzo email di risposta predefinito utilizzando {'{'}{'{'}contact.email{'}'}{'}'} per abilitare le risposte al contatto che invia il modulo.",
    "content" : "Contenuti",
    "calculations" : "Calcoli",
    "uploadOptions" : "Opzioni di caricamento",
    "opportunitySettingsWarning" : "Per configurare le impostazioni dell'opportunità, fai clic sul pulsante Modifica impostazioni opportunità.",
    "question" : "Domanda",
    "createContactOnPartialSubmission" : "Crea contatto con invio parziale",
    "howItWorks" : "Come funziona?",
    "createContactOnPartialSubmissionDescription" : "Termina la diapositiva e fai clic su \"Successivo\". Un nuovo contatto verrà creato e memorizzato automaticamente.",
    "swapWarningMessageSurvey" : "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. Può anche resettare la logica condizionale. ",
    "swapWarningMessageForm" : "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Etichetta opzione",
    "calculationValue" : "Valore di calcolo",
    "addOption" : "Aggiungi opzione",
    "enableCalculations" : "Abilita calcoli",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Abilitazione individuale o selezione di Prodotti multipli",
    "multi" : "Multi",
    "single" : "Individuo",
    "productSelectionHeading" : "Selezione Prodotto",
    "spreadToColumns" : "Diffondi in colonne",
    "columns" : "Colonne",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Incorpora Iframe",
      "funnel" : {
        "funnel" : "Funnel",
        "chooseStep" : "Seleziona a Passaggio",
        "copyCodeAndOpenFunnel" : "Copia Codice e Apri Funnel"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Condividi tramite Social",
        "copyLink" : "Copia link"
      },
      "email" : {
        "email" : "Email",
        "shareViaEmail" : "Condividi tramite Email",
        "emailButton" : "Email",
        "blankTemplate" : "Modello vuoto",
        "emailMarketingTemplates" : "Modelli Email Marketing",
        "or" : "O",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Continua"
      }
    },
    "rating" : {
      "icon" : "Icona",
      "iconAlignment" : "Allineamento Icona",
      "count" : "Numero",
      "lowestRating" : "Valutazione minima",
      "highestRating" : "Valutazione Massimo",
      "iconSelectedState" : "Stato Icona Selezionato",
      "iconUnselectedState" : "Stato Icona non selezionato",
      "rating" : "Valutazione",
      "ratingSettings" : "Impostazioni Valutazione",
      "calculationType" : {
        "calculationType" : "Come Archivia Valutazione Campi in Personalizzato Campi",
        "calculationTypeTooltip" : "Quando Tu Frequenza qualcosa di 4 Da 5 stelle, significa: - Assoluto: 4 Da 5 - Percentuale: 80 - Frazione: 0.8",
        "absolute" : "Assoluto",
        "percentage" : "Percentuale",
        "fraction" : "Frazione"
      }
    },
    "desktopMode" : "Modalità desktop",
    "mobileMode" : "Modalità mobile",
    "versions" : "Varianti",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "customValues" : "Valori personalizzati",
    "pickBgFromImage" : "Seleziona un Colore di Sfondo dall'Immagine di Sfondo del Modulo.",
    "pickBgFromImageTip" : "Consente di selezionare un Colore con Confronta elevato per l'Immagine BG. Messaggio: non verrà applicata se lo Sfondo del Modulo non ha un'Immagine",
    "messageBackgroundBlur" : "Sfocatura dello sfondo del messaggio",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Elimina opzione",
    "deleteConfirmationModal" : {
      "defaultDescription" : "L'eliminazione di un'opzione influirà su questa Personalizzato Campo su ogni Posti in cui viene utilizzato Campo. Sei sicuro che tu desideri eliminarlo?",
      "validationMessage" : "Inserisci Elimina in Salva.",
      "validationError" : "Inserisci Elimina"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "Impostazioni Generale",
    "advancedSettings" : "Impostazioni avanzate",
    "customFieldName" : "Personalizzato Settore Nome",
    "customFieldNameTooltip" : "Questo Settore Nome è unico per Personalizzato Settore.",
    "uniqueKey" : "Chiave univoca",
    "uniqueKeyTooltip" : "Questa Chiave è unica per Personalizzato Settore.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Interrogatorio del quiz",
    "choiceElements" : "Scelta componenti",
    "otherElements" : "Altro Componenti",
    "listEditor" : {
      "prefillValueHeader" : "Valore Precompila",
      "labelPlaceholder" : "Etichetta",
      "valuePlaceholder" : "Valore",
      "optionRequiredError" : "L'opzione Campo è Obbligatorio"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Aggiungi Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "numero"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipi File",
      "all" : "ogni",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Ok",
    "select" : "Seleziona",
    "allowMultipleFiles" : "Abilita File multipli",
    "maxFileLimit" : "Limite Massimo File",
    "privacyPolicy" : "Informativa sulla privacy",
    "termsOfService" : "Termini di servizio"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Scelta individuale",
      "multipleChoice" : "Scelta multipla",
      "yesNo" : "Sì / No",
      "shortAnswer" : "Video breve Risposto",
      "longAnswer" : "Risposto lungo",
      "number" : "numero",
      "singleDropdown" : "Elenco a discesa individuale",
      "multiDropdown" : "Elenco a Elenco a discesa multiplo"
    },
    "personal" : {
      "fullName" : "Nome Pieno",
      "firstName" : "Nome",
      "lastName" : "ultimo Nome",
      "dateOfBirth" : "Data di nascita",
      "phone" : "Telefono",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Pulsante"
    },
    "integration" : {
      "sellProducts" : "Vendi prodotti",
      "collectPayment" : "Raccogli Pagamento"
    },
    "address" : {
      "address" : "Indirizzo",
      "streetAddress" : "Indirizzo",
      "city" : "Città",
      "state" : "Stato",
      "country" : "Paese",
      "postalCode" : "Codice postale",
      "organization" : "Gruppo",
      "website" : "Sito web",
      "websitePlaceholder" : "L'URL web va qui"
    },
    "text" : {
      "singleLine" : "Linea individuale",
      "multiLine" : "Linea",
      "textBoxList" : "Testo Quadrato"
    },
    "choiceElements" : {
      "singleDropdown" : "Elenco a discesa individuale",
      "multiDropdown" : "Elenco a Elenco a discesa multiplo",
      "checkbox" : "Casella di controllo",
      "radio" : "Radio button"
    },
    "customized" : {
      "text" : "Clicca per modificare questo testo",
      "html" : "Html",
      "htmlPlaceholder" : "L'HTML Personalizzato va qui",
      "captcha" : "Captcha",
      "source" : "Fonte",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Accetto i termini e le condizioni Emesso tramite l'impresa. Tramite fornendo il mio Numero di telefono, accetto che Eredita Testo invii messaggi Da the business.",
      "score" : "Punteggio"
    },
    "other" : {
      "image" : "Immagine",
      "fileUpload" : "Carica File",
      "monetary" : "Monetario",
      "number" : "numero",
      "datePicker" : "Selettore Data",
      "signature" : "Firma"
    }
  },
  "survey" : {
    "typeOfBuilder" : "Sondaggio",
    "survyeStyle" : "Stile del sondaggio",
    "surveyName" : "Nome del sondaggio",
    "surveyElement" : "Elemento del sondaggio",
    "addSurveyElement" : "Aggiungi elemento del sondaggio",
    "unsavedAlertMessage" : "Il sondaggio contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage" : "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel sondaggio.",
    "integrateHeader" : "Integra sondaggio",
    "integrateSubHeader" : "Usa le seguenti opzioni per integrare il tuo sondaggio personalizzato nel tuo sito web",
    "integrateCopyLinkMessage" : "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "onSurveySubmission" : "All'invio del sondaggio",
    "surveySettings" : "Impostazioni sondaggio",
    "oneQuestionAtTime" : "Una domanda alla volta",
    "backButton" : "Pulsante Indietro",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Disabilita navigazione automatica",
    "disableAutoNavigationTooltipMessage" : "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "autoNavigation" : "Navigazione Automatico",
    "autoNavigationTooltipMessage" : "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "progressBar" : "Barra di avanzamento",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Disabilita animazione",
    "disableAnimationTooltipMessage" : "Attivando questa opzione verrà disabilitata l'animazione di transizione della diapositiva",
    "scrollToTop" : "Scorri verso l'alto",
    "scrollToTopTooltipMessage" : "Se l'opzione è attivata, il sondaggio scorrerà verso l'alto nella diapositiva successiva",
    "footerHTML" : "Piè di pagina HTML",
    "footerHTMLMessage" : "Puoi scrivere CSS personalizzati (usando l'etichetta di stile) e HTML all'interno della stessa casella",
    "editFooter" : "Modifica piè di pagina",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Squalifica immediatamente",
    "disqualifyAfterSubmit" : "Squalifica dopo l'invio",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Questa diapositiva contiene più domande con una logica impostata. Ciò può causare alcuni comportamenti indesiderati",
    "addSlide" : "Aggiungi diapositiva",
    "settings" : "Impostazioni",
    "delete" : "Elimina",
    "slideDeleteAlertMessage" : "Vuoi davvero eliminare questa diapositiva?",
    "slideDeleteBetweenAlertMessage" : "Questo riorganizzerà le altre diapositive. Vuoi davvero eliminare questa diapositiva?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Nome diapositiva",
    "slidePosition" : "Posizione della diapositiva",
    "jumpTo" : "Salta a",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "L'attivazione di questa opzione acquisirà le informazioni sul fuso orario della persona che invia il sondaggio",
    "footer" : {
      "footer" : "Piè di pagina",
      "enableNewFooter" : "Abilita nuovo piè di pagina",
      "stickToSurvey" : " Fissa al sondaggio",
      "backgroundFill" : "Riempimento sfondo",
      "footerHeight" : "Altezza del piè di pagina",
      "enableProgressBar" : "Abilita barra di avanzamento",
      "buttons" : "Pulsanti",
      "button" : "Pulsante",
      "buttonType" : "Tipo di pulsante",
      "fillNext" : "Riempi (successivo)",
      "fillPrevious" : "Riempi (precedente)",
      "fillSubmit" : "Compila (Invia)",
      "textColor" : "Testo del pulsante",
      "position" : "Posizione",
      "previousText" : "Precedente (testo)",
      "nextText" : "Successivo (testo)",
      "submitText" : "Invia (testo)",
      "fillComplete" : "Riempimento completo",
      "fillInactive" : "Riempimento inattivo",
      "footerType" : "Tipo di piè di pagina",
      "stickToCard" : "Fissa alla scheda",
      "stickToPage" : "Fissa alla pagina",
      "stepTextColor" : "Passaggio Corpo Color",
      "progressBarFill" : "Riempi la Barra di avanzamento",
      "progressBarInactive" : "Barra di avanzamento Inattivo",
      "arrowFill" : "Riempi a Freccia",
      "submitColorMobile" : "Invia (Colore)",
      "arrowFillColor" : "Colore Riempi Freccia"
    },
    "surveyNotfication" : "Notifica del sondaggio",
    "style" : {
      "surveyPadding" : "Spaziatura del sondaggio"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Apri il Link Sondaggio"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo Sondaggio, o Seleziona a Modello e incorporalo immediatamente."
      }
    },
    "autoResponderSubheader" : "Invia un'email automatica alla persona che invia il sondaggio (l'email include una copia delle informazioni inserite nel sondaggio)",
    "switchToOneQuestionAtTimeOn" : "L'attivazione di \"Una domanda per dati\" interrompe la logica condizionale attuale",
    "switchToOneQuestionAtTimeOff" : "La disabilità \"Una domanda a un dato\" influisce sulla tua logica condizionale",
    "switchToOneQuestionAtTimeOnWarning" : "Alcune condizioni non funzioneranno più come previsto. Le domande Quando sono Presentazione one at a Data.",
    "switchToOneQuestionAtTimeOffWarning" : " Alcune condizioni progettate per Flusso della domanda individuale smetteranno di funzionare come previsto.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Modulo",
    "formStyle" : "Stile del modulo",
    "formElement" : "Elemento del modulo",
    "addFormElement" : "Aggiungi elemento modulo",
    "addConditionalLogic" : "Aggiungi logica condizionale",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Modulo in linea",
    "formName" : "Nome del modulo",
    "fullScreenMode" : "Modalità a schermo intero",
    "fullScreenModetooltip" : "L'attivazione di questa opzione farà sì che il modulo si espanda su tutta la larghezza del contenitore, estendendosi fino al bordo dell'area di incorporamento e aderendo alla larghezza del modulo.",
    "enableTimezoneForm" : "Attivando questa opzione si acquisiscono le informazioni sul fuso orario della persona che invia il modulo",
    "formSettings" : "Impostazioni del modulo",
    "unsavedAlertMessage" : "Il modulo contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage" : "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel modulo.",
    "onFormSubmission" : "All'invio del modulo",
    "integrateForm" : "Integra modulo",
    "embedlayoutType" : "Incorpora Digita Layout",
    "embedlayoutTypeSubMessage" : "Seleziona un layout da incorporare in un funnel o in un sito web esterno",
    "triggerType" : "Tipo di trigger",
    "showOnScrolling" : "Mostra su scorrimento",
    "showAfter" : "Mostra dopo",
    "seconds" : "secondi",
    "alwaysShow" : "Mostra sempre",
    "activationOptions" : "Opzioni di attivazione",
    "activateOn" : "Attiva il",
    "visit" : "visita",
    "alwaysActivated" : "Sempre attivato",
    "deactivationOptions" : "Opzioni di disattivazione",
    "deactivateAfterShowing" : "Disattiva dopo la visualizzazione",
    "times" : "volte",
    "deactiveOnceLeadCollected" : "Disattiva una volta raccolto il lead",
    "neverDeactivate" : "Non disattivare mai",
    "copyEmbedCode" : "Copia codice di incorporamento",
    "copyFormLink" : "Copia link del modulo",
    "openFormLink" : "Apri il link del modulo",
    "inline" : "In linea",
    "inlineDescription" : "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "inlineHoverDescription" : "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "popup" : "Popup",
    "popupDescription" : "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "popupHoverDescription" : "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "politeSlideIn" : "Pannello di cortesia",
    "politeSlideInDescription" : "Un pannello di cortesia appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "politeSlideInHoverDescription" : "Appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "stickySidebar" : "Barra laterale fissa",
    "stickySidebarDescription" : "Una barra laterale fissa apparirà a lato dello schermo e può essere ridotta a icona in una scheda che resta fissa al lato della finestra",
    "stickySidebarHoverDescription" : "Appaiono a lato dello schermo e possono essere ridotti a icona in una scheda che resta fissa al lato della finestra",
    "allowMinimize" : "Consenti riduzione a icona",
    "conditonalLogic" : {
      "conditions" : "Condizioni",
      "noExistingCondition" : "Ancora nessuna condizione esistente",
      "freeRoamMessage" : "Puoi girare liberamente senza regole, almeno per ora",
      "addNewCondition" : "Aggiungi nuova condizione",
      "redirectToUrl" : "Reindirizza all'URL",
      "displayCustomMessage" : "Visualizza messaggio personalizzato",
      "disqualifyLead" : "Squalifica il lead",
      "showHideFields" : "Mostra/Nascondi campi",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Reindirizza l'utente dopo l'invio",
      "displayCustomMessageSubText" : "Mostra messaggi basati sugli input di Attivo Utente",
      "disqualifyLeadSubText" : "Filtra le voci in condizioni specifiche",
      "showHideFieldsSubText" : "Modifica campo Visibilità in modo dinamico",
      "openBelowUrl" : "Apri l'URL sottostante",
      "showCustomMessage" : "Mostra messaggio personalizzato",
      "alertConditionDelete" : "Vuoi davvero eliminare questa condizione?",
      "deleteCondition" : "Elimina condizione",
      "conditionExecutedMessage" : "Le condizioni verranno eseguite dall'alto verso il basso.",
      "allOperationOptions" : {
        "isEqualTo" : "È uguale a",
        "isNotEqualTo" : "Non è uguale a",
        "contains" : "Contiene",
        "startsWith" : "Inizia con",
        "endsWith" : "Termina con",
        "isEmpty" : "È vuoto",
        "isFilled" : "È riempito",
        "before" : "Prima",
        "after" : "Dopo",
        "greaterThan" : "Maggiore di",
        "lessThan" : "Meno di"
      },
      "logic" : {
        "if" : "Se",
        "then" : "Allora",
        "and" : "E",
        "or" : "O"
      },
      "phoneAlertMessage" : "Per cercare numeri di telefono con un prefisso internazionale, devi includere esplicitamente il simbolo \"+\" nella query di ricerca.",
      "deleteAlertMessage" : "Vuoi davvero eliminare questo campo? Verrà rimossa anche la condizione associata a questo campo.",
      "deleteField" : "Elimina campo",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Titolo ridotto",
    "dragYourElementFromLeft" : "Trascina i tuoi elementi qui da sinistra",
    "formNotification" : "Notifica modulo",
    "style" : {
      "formPadding" : "Spaziatura modulo"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Apri il Link Modulo"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo modulo, o seleziona un modello e incorporalo immediatamente."
      }
    },
    "choosePosition" : "Seleziona Stato"
  },
  "quiz" : {
    "quizElement" : "Elemento del quiz",
    "quizNotification" : "Notifica quiz",
    "viewAndCustomise" : "Visualizza e personalizza",
    "categoryAndScore" : "Categoria e punteggio",
    "provideFeedback" : "Fornisci un feedback",
    "addQuizElement" : "Aggiungi elemento quiz",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Aggiungi domande",
    "dragAndDropQuestion" : "Trascina un elemento Domanda qui.",
    "addNewPage" : "Aggiungi Nuovo Pagina",
    "editTemplate" : "Modifica Modello",
    "category" : {
      "category" : "Categoria",
      "watchVideo" : "Visualizza questo Video per saperne di più Su come la categoria influisce sui risultati Pagina!",
      "useCategoryWhen" : "Usa categorie quando",
      "manageCategories" : "Gestisci Categorie",
      "howItWorks" : "Come funziona 🤔",
      "howItWorks2" : "Come funziona",
      "addCategoryMessage" : "Aggiungi una nuova categoria",
      "assignCategoryMessage" : "Assegna una categoria a ogni opzione",
      "editResultsMessage" : "Punteggio Mostra Categoria in Risultato Pagina",
      "addCategory" : "Aggiungi Categoria",
      "deleteCategoryAlertMessage" : "Eliminazione una categoria risulterà nella riposo di quella categoria in ogni Opzioni",
      "editOrAddNewCategories" : "Puoi modificare o includere nuove categorie",
      "toEvaluateTheResponder" : "Per confrontare il risponditore Attivo ha basato diversi fattori",
      "showMultipleCategoryScore" : "Mostra il punteggio di Mostra multipla categoria in Risultato Pagina",
      "displayVaryingContent" : "Visualizzazione variabile Contenuti Attivo i risultati Pagina dipende dalla categoria di punteggio di Attivo",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Aggiungi / Gestisci"
    },
    "quizSettings" : "Impostazioni del quiz",
    "onQuizSubmission" : "All'invio del quiz",
    "settings" : "Impostazioni",
    "deletePage" : "Elimina pagina",
    "quizResult" : {
      "resultTemplate" : "Modello di risultato",
      "quizResultAlertMessage" : "La pagina dei risultati scelti verrà mostrata una volta completato il quiz"
    },
    "autoResponderSubheader" : "Invia un'e-mail automatica alla persona che invia il quiz (l'e-mail include una copia delle informazioni inserite nel quiz)",
    "integrateHeader" : "Integra quiz",
    "integrateSubHeader" : "Usa le seguenti opzioni per integrare il tuo quiz personalizzato nel tuo sito web",
    "integrateCopyLinkMessage" : "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "pageLabel" : "Page {n}",
    "pageName" : "Nome della pagina",
    "pagePosition" : "Posizione della pagina",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Apri il Link del quiz"
      },
      "email" : {
        "emailSubheader" : "Crea Email vuota e incorpora il tuo quiz, o seleziona un modello e incorporalo immediatamente."
      }
    }
  }
}
